import { ActionCenterWelcome } from "@/action-center/components/action-center-welcome";
import { cn } from "@/core/lib/utils";
import type { ChatSession } from "../hooks/useChatSession";
import { ChatInput } from "./chat-input";
import { ChatSessionMessages } from "./chat-session-messages";

/**
 * Corpo do chat da Bruna (Figma Chat-Bruna 6087:32895): welcome em conversa
 * nova, mensagens e Input Chat. É o mesmo componente na página "Chat com a
 * Bruna" e no painel lateral das demais telas, para uma mudança numa valer na
 * outra. O contêiner (cartão, padding, cabeçalho) fica por conta de quem usa.
 */
export function BrunaChat({
  session,
  className,
}: {
  session: ChatSession;
  className?: string;
}) {
  const {
    inputValue,
    setInputValue,
    isLoading,
    hydrated,
    isWelcome,
    userInfo,
    extractionResult,
    sendMessage,
    handleEnter,
    handleHubShortcutClick,
    handleNewConversation,
    setExtractionResult,
    setExtractionConfirmed,
  } = session;

  return (
    <div className={cn("flex min-w-0 flex-col gap-5", className)}>
      <div className="min-h-0 flex-1 overflow-hidden">
        {/* O painel de validação de e-mails (upload de planilha) continua no
            corpo do chat. */}
        {isWelcome && !extractionResult ? (
          <ActionCenterWelcome onShortcutClick={handleHubShortcutClick} />
        ) : (
          <ChatSessionMessages session={session} />
        )}
      </div>
      <div className="shrink-0">
        <ChatInput
          value={inputValue}
          onChange={setInputValue}
          onSend={sendMessage}
          onEnter={handleEnter}
          variant="action-center"
          onNewConversation={() => handleNewConversation("header")}
          disabled={isLoading || !hydrated}
          allowedDomains={userInfo?.league?.domains ?? []}
          onFileParsed={(result) => {
            setExtractionResult(result);
            setExtractionConfirmed(false);
          }}
        />
      </div>
    </div>
  );
}
